import React from 'react';
import './index.scss';
const BackBtn = props => {
	function handleClick() {
		if (props.onClick) {
			props.onClick();
		} else {
			window.history.go(-1);
		}
	}

	let color = props.color || '#333';
	return (
		<div className="back-btn" onClick={handleClick}>
			<i className="iconfont arrow" style={{ color }}>
				&#xe655;
			</i>
			<span style={{ color }}>{props.text || '返回'}</span>
		</div>
	);
};
export { BackBtn };
